<template>
  <div class="registrationInstructions" id="registrationInstructions">
    <navbar/>
    <div class="row">
      <h3 class="text-center center-align application header" style="font-weight: 500;">APPLICATION FOR PLATINUM REASONING CONTEST 2018</h3>
      <a class="btn blue right waves-effect" id="frBtn" @click="toFr">FRANÇAIS</a>
      <a class="btn blue right waves-effect" id="enBtn" @click="toEn">ENGLISH</a>
      <div class="regContent col m4 l5 hide-on-small-only show-on-med-and-up">
        <ul class="section table-of-contents">
          <h4>&nbsp;Contents</h4>
          <hr/>
            <li><a href="#requirements">Call for Entry</a></li>
            <li><a href="#applicants">Who can apply</a></li>
            <li><a href="#provisions">Provision for disabled</a></li>
            <li><a href="#access">Access to contest</a></li>
            <li><a href="#closingDate">Application closing date</a></li>
            <li><a href="#fquestions">Have further questions?</a></li>
            <li><a href="#applyNow">How to apply?</a></li>
          </ul>
      </div>
      <div class="regContent col m8 s10 offset-s1 z-depth-2 l7 offset-l4" style=" padding: 2rem;" id="englishInstructions">
        <h4 class="text-center center-align">Registration is free!</h4>
        <hr/>
        <div class="appRequirements section scrollspy" id="requirements">
          <h4 class="left-align">Call for Entry</h4>
          <p class="requirementText">
            Application for Platinum Reasoning Contest 2018 is open to all students of higher institutions. An eligible student must be a bonafide student of any tertiary institutions in Africa.It includes the following categories:
            <ul>
              <li>College</li>
              <li>Polytechnic</li>
              <li>Undergraduate</li>
            </ul>
          </p>
        </div>
        <hr style="width: 70%; float: left"/><br/>
        <div class="applicants section scrollspy" id="applicants">
          <h4 class="left-align">Who can apply?</h4>
          <p class="appicantsText">
            <ul class="section table-of-contents">
              <li>Application is open to students in all fields.</li>
              <li>Students of any registered instutions within Africa.</li>
              <li>Application is not restricted to any levels of higher learning. That is, it is opened to students from all levels or classes of any tertiary institutions.</li>
            </ul>
          </p>
        </div>
        <hr style="width: 70%; float: left"/><br/>
        <div class="provision-for-disables section scrollspy" id="provision">
          <h4 class="left-align">Provision for disabled</h4>
          <p class="provisionText">
           There is provision for disabled as the application is opened to all qualified candidates.
          </p>
        </div>
        <hr style="width: 70%; float: left"/><br/>
        <div class="provision-for-disables section scrollspy" id="access">
          <h4 class="left-align">Access to contest</h4>
          <p class="provisionText">
            Registration is free,  all you need is your school identity card or admission letter and registration code(to ensure the target audience is the one registering).
            <br/><br/>
            <small class="note bold">NOTE:<br/>
              Charges may apply for result checking.
            </small>
          </p>
        </div>
        <hr style="width: 70%; float: left"/><br/>
        <div class="fquestions section scrollspy" id="fquestions">
          <h4 class="left-align">Have further questions?</h4>
          <p class="appicantsText">
           Do you have further questions or having trouble applying? Kindly mail us at: <br/><a href="mailto:support@pmg-c.org">Support@pmg-c.org </a>
          </p>
        </div>
        <hr style="width: 70%; float: left"/><br/>
        <div class="closing-date section scrollspy" id="closingDate">
          <h4 class="left-align">Application Closing Date</h4>
          <p class="appicantsText">
           Application closes July 30, 2018.
          </p>
        </div>
        <hr style="width: 70%; float: left"/><br/>
        <div class="applyNow section scrollspy" id="applyNow">
          <h4 class="left-align">How to Apply?</h4>
          <p class="appyText">
            Ensure you read the instructions on the registration page carefully before you submit.
            Click the button below to proceed.
          </p>
          <router-link :to="toRegistration" class="btn blue center-align text-center white-text">Proceed</router-link>
        </div>
      </div>

      <div class="regContent col m8 s10 offset-s1 z-depth-2 l7 offset-l4" style=" padding: 2rem;" id="frenchInstructions">
        <h4 class="text-center center-align">L'inscription est gratuite!</h4>
        <hr/>
        <div class="appRequirements section scrollspy" id="requirements">
          <h4 class="left-align">Appel à l'entrée</h4>
          <p class="requirementText">
            La candidature au concours Platinum Reasoning 2018 est ouverte à tous les étudiants des établissements supérieurs. Un étudiant éligible doit être un étudiant de bonne foi de tous les établissements d'enseignement supérieur en Afrique.Il comprend les catégories suivantes:
            <ul>
              <li>Université</li>
              <li>Polytechnique</li>
              <li>Étudiants de premier cycle</li>
            </ul>
          </p>
        </div>
        <hr style="width: 70%; float: left"/><br/>
        <div class="applicants section scrollspy" id="applicants">
          <h4 class="left-align">Qui peut postuler?</h4>
          <p class="appicantsText">
            <ul class="section table-of-contents">
              <li>
L'application est ouverte aux étudiants dans tous les domaines.</li>
              <li>
Étudiants de toutes les institutions enregistrées en Afrique.
</li>
              <li>L'application n'est limitée à aucun niveau d'enseignement supérieur. Autrement dit, il est ouvert aux étudiants de tous les niveaux ou classes de toutes les institutions tertiaires.</li>
            </ul>
          </p>
        </div>
        <!-- <hr style="width: 70%; float: left"/><br/> -->
        <!-- <div class="provision-for-disables section scrollspy" id="provision">
          <h4 class="left-align">Provision for disabled</h4>
          <p class="provisionText">
           There is provision for disabled as the application is opened to all qualified candidates.
          </p>
        </div> -->
        <hr style="width: 70%; float: left"/><br/>
        <div class="provision-for-disables section scrollspy" id="access">
          <h4 class="left-align">
Accès au concours</h4>
          <p class="provisionText">
           L'inscription est gratuite, tout ce dont vous avez besoin est votre carte d'identité scolaire ou votre lettre d'admission et votre code d'inscription (pour vous assurer que le public cible est celui qui s'enregistre).
            <br/><br/>
            <small class="note bold">REMARQUE:<br/>
             Des frais peuvent s'appliquer pour la vérification des résultats.
            </small>
          </p>
        </div>
        <hr style="width: 70%; float: left"/><br/>
        <div class="fquestions section scrollspy" id="fquestions">
          <h4 class="left-align">Avez-vous d'autres questions?</h4>
          <p class="appicantsText">
           Avez-vous d'autres questions ou avez-vous de la difficulté à poser votre candidature? Veuillez nous envoyer un courriel à:<br/><a href="mailto:support@pmg-c.org">Support@pmg-c.org </a>
          </p>
        </div>
        <hr style="width: 70%; float: left"/><br/>
        <div class="closing-date section scrollspy" id="closingDate">
          <h4 class="left-align">Date de clôture de la demande</h4>
          <p class="appicantsText">
L'application se termine le 30 juillet 2018.
          </p>
        </div>
        <hr style="width: 70%; float: left"/><br/>
        <div class="applyNow section scrollspy" id="applyNow">
          <h4 class="left-align">Comment s'inscrire?</h4>
          <p class="appyText">  Assurez-vous de lire attentivement les instructions sur la page d'inscription avant de soumettre.
            Cliquez sur le bouton ci-dessous pour continuer.
          </p>
          <router-link :to="toRegistration" class="btn blue center-align text-center white-text">Procéder</router-link>
        </div>
      </div>
    </div>
    <footer-page/>
    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from '@/components/layouts/navbar'
import FooterPage from '@/components/layouts/footer-page'
import $ from 'jquery'
export default {
  components: {Navbar, FooterPage},
  mounted () {
    $('#frenchInstructions').hide()
    $('#enBtn').hide()
    var scrolSelect = document.querySelector('.scrollspy')
    // eslint-disable-next-line
    var instance = new M.ScrollSpy(scrolSelect, {
      activeClass: 'active'
    })
    if (this.$route.fullPath.split('-')[6]) {
      this.toRegistration = `/platinum-reasoning-contest-2018-register-candidate-${this.$route.fullPath.split('-')[6]}`
    }
    // console.log(this.$route.params[0])
  },
  methods: {
    toEn () {
      $('#englishInstructions').show()
      $('#frenchInstructions').hide()
      $('#enBtn').hide()
      $('#frBtn').show()
    },
    toFr () {
      $('#englishInstructions').hide()
      $('#frenchInstructions').show()
      $('#enBtn').show()
      $('#frBtn').hide()
    }
  },
  data () {
    return {
      toRegistration: `/platinum-reasoning-contest-2018-register-candidate`
    }
  }
}
</script>

<style>
  h3.text-center.center-align.header.application {
    font-size: 2rem;
  }
  div.registrationInstructions > div.row {
    padding-top: 0%;
  }
  div.registrationInstructions > div.row > div.regContent.col.m4.l5 > ul > li > a {
    font-size: 16.5px
  }
  div.registrationInstructions > div.row > div.regContent.col.m4.l5 > ul.table-of-contents > li {
    padding: 3px 0;
  }
  div.registrationInstructions > div.row > div.regContent.col.m4.l5 > ul.table-of-contents {
    position: absolute;
    padding-top: 0rem;
  }
</style>



// WEBPACK FOOTER //
// src/pmgc/registration/regInstructions.vue